export const status = {
  ALL: 'ALL',
  WAITING: 'WAITING',
  PENDING: 'PENDING',
  LATED: 'LATED',
  CANCELED: 'CANCELED',
  SUCCESS: 'SUCCESS',
}

export const type = {
  ALL: 'ALL',
  CLIENT: 'CLIENT',
  SUPPLIER: 'SUPPLIER',
}

export const typeText = {
  ALL: 'ทั้งหมด',
  CLIENT: 'ลูกค้า',
  SUPPLIER: 'ผู้จ้าง',
}

export const statusText = {
  ALL: 'ทั้งหมด',
  WAITING: 'รอการดำเนินการ',
  PENDING: 'กำลังดำเนินการ',
  LATED: 'เลยกำหนดการ',
  CANCELED: 'ยกเลิก',
  SUCCESS: 'สำเร็จ',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}
